import { render, staticRenderFns } from "./addPlsc.vue?vue&type=template&id=f7fdff5c"
import script from "./addPlsc.vue?vue&type=script&lang=js"
export * from "./addPlsc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports